const questions = [
// GK 
{
    question: " केन्द्रीयविद्यालय-संगठनस्य ध्येयवाक्यं किम् ?",
    choice1: 'सत्यमेव जयते',
    choice2: 'तत् त्वं पूषन् अपावृणु',
    choice3: 'सत्यं शिवं सुन्दरम्',
    choice4: 'विद्ययाऽमृतमश्नुते', 
    answer: 2,
},
{
    question: "महाभारतं कः रचितवान् ?",
    choice1: 'वाल्मीकि:',
    choice2: 'कालिदास:',
    choice3: 'भास:',
    choice4: 'व्यास:', 
    answer: 4,
},
{
    question: "पञ्चतन्त्रम् - इत्यस्य लेखक: क:?",
    choice1: 'विष्णुशर्मा,',
    choice2: 'कालिदास:',
    choice3: 'व्यास:',
    choice4: 'भास:', 
    answer: 1,
},
{
    question: "रामायणे कति काण्डानि सन्ति?",
    choice1: '5',
    choice2: '7',
    choice3: '19',
    choice4: '17', 
    answer: 2,
},
{
    question: "रामायणे कस्य अन्यनाम “दाशरथि:”?",
    choice1: 'हनुमान्',
    choice2: 'लक्ष्मण:',
    choice3: 'भरत:',
    choice4: 'राम:', 
    answer: 4,
},
{
    question: "श्रीकृष्ण: अर्जुनाय महाभारतयुद्धसमये किं बोधितवान् ?",
    choice1: 'गीताम्',
    choice2: 'रामायणम्',
    choice3: 'शाकुन्तलम्',
    choice4: 'रामचरितमानसम्', 
    answer: 1,
},
{
    question: "महाभारतानुसारं “देवव्रत:” क:?",
    choice1: 'भीम:',
    choice2: 'अर्जुन:',
    choice3: 'कर्ण:',
    choice4: 'भीष्म:', 
    answer: 4,
},
{
    question: "योगदर्शनस्य रचयिता क:?",
    choice1: 'वाल्मीकि:',
    choice2: 'स्वामी रामदेव:',
    choice3: 'पतंजलि:',
    choice4: 'पाणिनि:', 
    answer: 3,
},
{
    question: "वेदा: कति सन्ति ?",
    choice1: 'दश',
    choice2: 'चत्वार:',
    choice3: 'पंच',
    choice4: 'नव', 
    answer: 2,
},
{
    question: " संस्कृतदिनोत्सव: कदा आचर्यते?",
    choice1: 'आषाढपूर्णिमायाम्,',
    choice2: 'भाद्रपूर्णिमायाम्',
    choice3: 'दीपावलिअमावास्यायाम्',
    choice4: 'श्रावणपूर्णिमायाम्,', 
    answer: 4,
},
{
    question: "चतुर्णां भुजानां समाहार: इत्यनेन लौकिक विग्रहेण निष्पन्न चतुर्भुज: पदे समास: अस्ति ?",
    choice1: 'कर्मधारय:',
    choice2: 'द्विगु:',
    choice3: 'अव्ययीभाव',
    choice4: ' बहुव्रीहि', 
    answer: 2,
},
{
    question: "कस्मिन विकल्पे सुसमासमभवत ?",
    choice1: 'उद्गतं काकुदम् यस्य स:–उत्काकुद',
    choice2: 'विगतँ काकुदम् यस्य स:–विकाकुद:',
    choice3: 'पूर्णं काकुदम् यस्य स:– पूर्णकाकुद:',
    choice4: 'एषु सर्वेषु', 
    answer: 3,
},
{
    question: "लोकनाथ: इत्यस्मिन पदे समास:वर्तते ?",
    choice1: 'अव्ययीभाव:',
    choice2: 'बहुव्रीहि:',
    choice3: 'सुप्सुपा',
    choice4: 'तत्पुरुष', 
    answer: 2,
},
{
    question: "सहस्त्राणाम् अब्दानां समाहार:….?",
    choice1: 'सहस्त्राब्दि:',
    choice2: 'सहस्त्राब्दी',
    choice3: 'सहस्त्राब्द:',
    choice4: 'सहस्त्राब्दम्', 
    answer: 2,
},
{
    question: "निर्मक्षिकम् अस्य पदस्य अलौकिक विग्रह:अस्ति? ",
    choice1: 'निर्+मक्षिका+अम्',
    choice2: 'मक्षिका+टा+निर्',
    choice3: 'मक्षिका+सु+निर्',
    choice4: 'मक्षिका+आम्+निर्', 
    answer: 4,
},
{
    question: "निम्नांकितेषु सुम्मिलितं पदमस्ति ?",
    choice1: 'दंतानाम् राजा=राजदंत:',
    choice2: 'चित्रा:गाव:यस्य स: = चित्रगु:',
    choice3: 'प्रपतितानि प्रणानि यस्मात् स:=प्रपर्ण:',
    choice4: ' सर्वे:', 
    answer: 4,
},
{
    question: "प्राप्तधन: इत्यस्य सुविग्रह: अस्ति ?",
    choice1: 'प्राप्तं धनम् यस्य स:',
    choice2: 'प्राप्तं धनम् यस्मै स:',
    choice3: ' प्राप्तं धनम् यं स:✔',
    choice4: 'प्राप्तं धनम् यस्मात् स:', 
    answer: 3,
},
{
    question: "भिक्षामट् गां च आनय इदं द्वद्वसमासस्य कस्य भेदस्य उदाहरणमस्ति ?",
    choice1: ' समुच्चय:',
    choice2: 'अन्वाचय:',
    choice3: ' इतरेतर:',
    choice4: 'समाहार:', 
    answer: 2,
},
{
    question: "दीर्घग्रीव: पदे समास: अस्ति ?",
    choice1: 'बहुव्रीहि:',
    choice2: 'कर्मधारय:',
    choice3: 'अव्ययीभाव',
    choice4: 'तत्पुरुष', 
    answer: 1,
},
{
    question: "अन्न बुभुक्षु: इत्यस्य समासविग्रह भवति ?",
    choice1: 'अन्नेन बुभुक्षु:',
    choice2: 'अन्नं बुभुक्षु:',
    choice3: 'अन्नस्य बुभुक्षु:',
    choice4: 'अन्नेन बुभुक्षु:', 
    answer: 2,
},
{
    question: "अलुक् तत्पुरुषस्योदाहरणमस्ति ?",
    choice1: 'अनश्वर:',
    choice2: 'अवकोकिल:',
    choice3: 'चित्रकार:',
    choice4: 'युधिष्ठिर:', 
    answer: 4,
},
{
    question: "पंचमेजनम् इत्यत्र क: समास: ?",
    choice1: 'अव्ययीभाव',
    choice2: ' द्विगु:',
    choice3: 'कर्मधारय:',
    choice4: 'बहुव्रीहि', 
    answer: 1,
},
{
    question: "अध्यात्मम् इत्यस्य शुद्ध विग्रहमस्ति ?",
    choice1: 'आत्मनि इति',
    choice2: 'आत्मने इति',
    choice3: 'आत्मना इति',
    choice4: 'अधि आत्मन', 
    answer: 1,
},
{
    question: "शुक्लीकृत्य पदे समास:अस्ति ?",
    choice1: 'गति तत्पुरुष:',
    choice2: 'प्रादी तत्पुरुष:',
    choice3: 'अलुक् तत्पुरुष:',
    choice4: 'उपपद तत्पुरुष:', 
    answer: 1,
},
{
    question: "संस्कृते कति समासा: ?",
    choice1: '४',
    choice2: ' ५',
    choice3: '६',
    choice4: '७', 
    answer: 2,
},
{
    question: "‘वह ब्राह्मण को धन देता है |’ अस्य वाक्यस्य संस्क्रतानुवाद: अस्ति ?",
    choice1: ' स: विप्र धनं ददाति',
    choice2: 'स: विप्रेण धनं ददाति',
    choice3: 'स: विप्राय धनं ददाति',
    choice4: 'स: विप्रस्य धनं ददाति', 
    answer: 3,
},
{
    question: "‘वह विधालय की ओर जाता है |’ अस्य वाक्यस्य संस्क्रतानुवाद: अस्ति –",
    choice1: 'स: विधालायास्य प्रति गच्छति',
    choice2: 'स: विधालायेंन प्रति गच्छति',
    choice3: 'स: विधालायात प्रति गच्छति',
    choice4: 'स: विधालायं प्रति गच्छति', 
    answer: 4,
},
{
    question: "‘मोहन गेंद से खेलता है |’ अस्य वाक्यस्य संस्क्रतानुवाद: अस्ति –",
    choice1: 'मोहन: कन्दुकान क्रीडति',
    choice2: 'मोहन: कन्दुकं क्रीडति',
    choice3: 'मोहन: कन्दुकेन क्रीडति',
    choice4: 'मोहन: कन्दुकाय क्रीडति', 
    answer: 3,
},
{
    question: "‘मया पाठ: पठनीय: |’ रेखाकिन्तापदे प्रत्यय: अस्ति",
    choice1: 'तव्यत',
    choice2: 'अनीयर',
    choice3: 'तमप',
    choice4: 'तमुन', 
    answer: 2,
},
{
    question: "‘छोत्रेशु मोहन पतुतम: |’ रेखानिद्क्त्पदे प्रत्यय अस्ति",
    choice1: 'तरप',
    choice2: 'तमप',
    choice3: 'क्तवतु',
    choice4: 'तमुन', 
    answer: 2,
},
{
    question: "‘कथित:’ अत्र धातु: प्रत्यय्श्च स्त: –",
    choice1: 'कथ+क्त',
    choice2: 'कथ+क्तवतु',
    choice3: 'कथ+शतर्',
    choice4: 'कथ+शानच्', 
    answer: 1,
},
{
    question: "‘रामकृष्नौ’ अस्मिन् पदे समास-विग्रह: अस्ति-",
    choice1: 'राम: च कृष्ण: च',
    choice2: 'रामम च कृष्णम च',
    choice3: 'रामेण च कृष्णेन च',
    choice4: 'राम: च राम: च', 
    answer: 1,
},
{
    question: "‘अधिहरी’ अस्मिन पदे समास: अस्ति-",
    choice1: 'तत्पुरुष:',
    choice2: 'अव्ययी भाव:',
    choice3: 'द्विगु:',
    choice4: 'बहुब्रिही:', 
    answer: 2,
},
{
    question: "‘निलोत्पलम’ अस्मिन पदे समास: अस्ति –",
    choice1: 'द्विगु:',
    choice2: 'द्वन्द:',
    choice3: 'कर्मधारय:',
    choice4: 'बहुब्रीहि:', 
    answer: 3,
},
{
    question: "प्रायेण उत्तरपदार्थ प्रधान: भवति-",
    choice1: 'अव्ययीभाव समासे',
    choice2: 'तत्पुरुष समासे',
    choice3: 'बहुब्रीहि समासे',
    choice4: 'कर्मधारय समासे', 
    answer: 2,
},
{
    question: "‘वनौषधि:’ अत्र संधिविच्छेद: अस्ति-",
    choice1: 'वनौ+षधि:',
    choice2: 'वनों+ओषधि:',
    choice3: 'वन+औषधी:',
    choice4: 'वने+ओषधि:', 
    answer: 3,
},
{
    question: "‘वागीश:’ अत्र संधि: अस्ति-",
    choice1: 'श्चुत्व',
    choice2: 'जशत्व',
    choice3: 'ष्टुँत्व',
    choice4: 'उत्व', 
    answer: 2,
},
{
    question: "‘इति+अपि’ अत्र संधि: भविष्यति-",
    choice1: 'इत्यपि',
    choice2: 'इत्यापि',
    choice3: 'इतिपि',
    choice4: 'इतीपि', 
    answer: 1,
},
{
    question: "‘नायक:’ इत्यस्य पदस्य संधिविच्छेद: अस्ति-",
    choice1: 'ने+अक:',
    choice2: 'नै+अक:',
    choice3: 'नो+अक',
    choice4: 'नौ+अक:', 
    answer: 2,
},
{
    question: " ‘अभीत: परित: योगे’ विभक्ति: भवति-",
    choice1: 'प्रथमा',
    choice2: 'द्वितीय',
    choice3: 'तृतीया',
    choice4: 'चतुर्थी', 
    answer: 2,
},
{
    question: " ‘………. सह बालक: गच्छति’ | रिक्तस्थाने शुद्धरूपं भविष्यति-",
    choice1: 'पिता',
    choice2: 'पितरम्',
    choice3: 'पित्रा',
    choice4: 'पित्रे', 
    answer: 3,
},
{
    question: "‘थ’ व्यंजन्स्य उच्चारणस्थान भवति-",
    choice1: 'तालु:',
    choice2: 'मूर्धा:',
    choice3: 'कन्ठ:',
    choice4: 'दंता:', 
    answer: 4,
},
{
    question: "‘अम’ धातो: ल्रट लकारे प्रथमपुरुष एकवचने रूपं भवति-",
    choice1: 'अस्ति',
    choice2: 'भविष्यन्ति',
    choice3: 'भविष्यति',
    choice4: 'A व् B', 
    answer: 3,
},
{
    question: "‘दर्श’ धातो: लट लकारे प्रथमपुरुष बहुवचने रूपमस्ति –",
    choice1: 'द्रक्ष्यति',
    choice2: 'द्रक्ष्यन्ति',
    choice3: 'पश्यति',
    choice4: 'पश्यन्ति', 
    answer: 2,
},
{
    question: "‘सेव’ धातो: लड् लकारे उत्तमपुरुष एकवचने रूपं भवति-",
    choice1: 'असेवत',
    choice2: 'असेवंत',
    choice3: 'असेवे',
    choice4: 'असेवथा', 
    answer: 3,
},
{
    question: "″तद् अस्य अस्ति” “तद् अस्मिन अस्ति” अर्थे प्रत्यय भवति-",
    choice1: 'तरप्',
    choice2: 'मतुप्',
    choice3: 'वतुप्',
    choice4: 'तल्', 
    answer: 2,
},
{
    question: "लिख्+कत्वा इति भवति-",
    choice1: 'लिखित्वा',
    choice2: 'लेखित्वा',
    choice3: 'लिखत्वा',
    choice4: 'अ,ब उभयो', 
    answer: 4,
},
{
    question: "कृतसंज्ञा विधायकम् सूत्रं अस्ति-",
    choice1: 'कर्तरि कृत',
    choice2: 'कृद्तिङ',
    choice3: 'इद्यति',
    choice4: 'कर्मण्य', 
    answer: 2,
},
{
    question: "कृ धातु क्यप् प्रत्ययस्य रूपं अस्ति-",
    choice1: 'कार्यम्',
    choice2: 'कृत्यम्',
    choice3: 'उभयो',
    choice4: 'कृट्', 
    answer: 2,
},
{
    question: "दा-धातो सत् संज्ञक प्रत्यय अस्ति-",
    choice1: 'शतृ',
    choice2: 'शानच्',
    choice3: 'शतृ शानचौ',
    choice4: 'कानच्', 
    answer: 3,
},
{
    question: "भ्रम् धातु कत्वा प्रत्ययान्त रूपमस्ति-",
    choice1: 'भ्रमित्वा',
    choice2: 'भ्रान्त्वा',
    choice3: 'उभयो',
    choice4: 'भृमित्वा', 
    answer: 3,
},
{
    question: "पा रक्षणे कत्वा प्रत्ययान्त रुपम् भविष्यति-",
    choice1: 'पित्वा',
    choice2: 'पात्वा',
    choice3: 'पांत्वा',
    choice4: 'पीत्वा', 
    answer: 2,
},
{
    question: "मृजेर्वद्धि:” इति सूत्रेण निष्पन्न रूपं अस्ति",
    choice1: 'मार्ग्य:',
    choice2: 'मर्ज़:',
    choice3: 'मृज्य:',
    choice4: 'सर्वे', 
    answer: 1,
},
{
    question: "अट् धातु स्त्रीलिंगे शतृ प्रत्ययान्त रूपं अस्ति",
    choice1: 'अतंति',
    choice2: 'अटन्ती',
    choice3: 'अटन्ति',
    choice4: 'सर्वे', 
    answer: 2,
},
{
    question: "कस्मिन् प्रत्ययात्  निर्मितं पदं अव्ययपदं नास्ति-",
    choice1: 'तुमुन',
    choice2: 'क्त',
    choice3: 'कत्वा',
    choice4: 'ल्यप', 
    answer: 2,
},
{
    question: "“ज्ञानम् अस्ति” अस्मिन अर्थे रूपं भविष्यति",
    choice1: 'ज्ञानवती',
    choice2: 'ज्ञानमती',
    choice3: 'ज्ञानवान्',
    choice4: 'ज्ञानमान', 
    answer: 3,
},
{
    question: "क्तवतु “प्रत्यय कस्मिन अर्थे प्रयुक्ते-",
    choice1: 'भाव',
    choice2: 'कर्म',
    choice3: 'कर्ता',
    choice4: 'कर्ता और कर्म', 
    answer: 3,
},
{
    question: "उद् -पूर्वक श्वि धातवे: क्त प्रत्ययस्य रूपं भविष्यति-",
    choice1: 'उच्छुत:',
    choice2: 'उच्छून:',
    choice3: 'उच्छूण:',
    choice4: 'सर्वे', 
    answer: 3,
},
{
    question: "अधोलिखितेषु निष्ठांत रूपं नास्ति- –",
    choice1: 'शुष्क:',
    choice2: 'पूत:',
    choice3: 'पूर्ण:',
    choice4: 'क्षाण:', 
    answer: 4,
},
{
    question: "कृ धातु शतृप्रत्ययस्य रूपं भविष्यति-",
    choice1: 'कुर्वन्ति',
    choice2: 'कुर्वती',
    choice3: 'करोती',
    choice4: 'करवंती', 
    answer: 2,
},
]

export default questions